export const checkIsFilterUsed = ({ article_type, from, to }) =>
  Boolean(article_type || from || to)
